import { useState } from 'react';
import AndreaC from '../assets/staff/andrea-cerulli.webp';
import GaiaD from '../assets/staff/gaia-donaduzzi.webp';
import RominaS from '../assets/staff/romina-sinigagllia.webp';
import MilenaB from '../assets/staff/milena-bovolenta.webp';
import MonicaM from '../assets/staff/monica-mantovani.webp';
import GiorgiaT from '../assets/staff/giorgia-tinelli.webp';
import BarbaraL from '../assets/staff/barbara-lorenzoni.webp';
import RebellaA from '../assets/staff/andrea-rebella.jpg';
import MarcelaS from '../assets/staff/marcela-salazar.webp';
import PaolaP from '../assets/staff/paola-pasqualin.webp';
import SaraB from '../assets/staff/sara-begalli.webp';
import JodyF from '../assets/staff/fustini2_staff.jpg';
import MicheleM from '../assets/staff/michele-malagnini.webp';
import TommasoP from '../assets/staff/tommaso-poli.webp';
import AlessioC from '../assets/staff/alessio-cutrona.webp';
import VirajP from '../assets/staff/viraj-perera.webp';
import BeatriceM from '../assets/staff/beatrice-murari.webp';
import User from '../assets/staff/userimg.webp';
import AndreaGuerra from '../assets/staff/andrea-guerra.webp';
import BeatriceRuzzenente from '../assets/staff/beatrice-ruzzenente.png';
import NataliaM from '../assets/staff/natalia-matei.webp';
import StefaniaF from '../assets/staff/stefania-farris.webp';
import GermanoP from '../assets/staff/germano-pomari.webp';
import IradaP from  '../assets/staff/irada-pallanca.webp';
import CristianT from  '../assets/staff/trusca1_staff.jpg';
import Zeggiotti from  '../assets/staff/zeggiotti1_staff.jpg';
import Silvestri from  '../assets/staff/silvestri2_staff.jpg';
import Cosimo from '../assets/staff/cosimo-russo.jpg';
import Roberta from  '../assets/staff/roberta.webp';
import Arianna from  '../assets/staff/arianna.webp';
import NewImage from '../assets/mfxeded/giphy (2).gif';
import NewVideo from '../assets/mfxeded/anim.mp4';
import DonataN from '../assets/staff/donata-negretto.webp';
import DianaPetrisor from '../assets/staff/diana-petrisor.webp';
import AldoCarbone from '../assets/staff/aldo-carbone.webp';
import JessicaSchena from '../assets/staff/jessica-schena.webp';
import AliceZuffellato from '../assets/staff/alice-zuffellato.webp';
import DennyDecaro from '../assets/staff/denny-decaro.webp';
import MatteoMerlin from '../assets/staff/matteo-merlin.webp';
import MicheleLochi from '../assets/staff/michele-lochi.png';
import MattiaZapparoli from '../assets/staff/mattia-zapparoli.png';
import ChiaraBissolo from '../assets/staff/chiara-bissolo2.jpg';
import DenisR from '../assets/staff/denis-righelli.png';

const people = [
    {
        name: 'Andrea Cerulli',
        role: 'Chief Financial Officer',
        imageUrl:AndreaC,
    },
    {
        name: 'Stefania Farris',
        role: 'Accounting Manager',
        imageUrl:StefaniaF
    },
    {
        name: 'Gaia Donaduzzi',
        role: 'Accounting',
        imageUrl:GaiaD
    },
    {
        name: 'Natalia Matei',
        role: 'Accounting',
        imageUrl:NataliaM
    },
    {
        name: 'Aldo Carbone',
        role: 'Accounting',
        imageUrl:AldoCarbone
    },
    {
        name: 'Germano Pomari',
        role: 'Customer Care Manager',
        imageUrl:GermanoP
    },
    {
        name: 'Romina Sinigaglia',
        role: 'Customer Care',
        imageUrl:RominaS
    },
    {
        name: 'Beatrice Murari',
        role: 'Customer Care',
        imageUrl: BeatriceM
    },
    {
        name: 'Donata Negretto',
        role: 'Customer Care',
        imageUrl: DonataN
    },
    {
        name: 'Jessica Schena',
        role: 'Customer Care',
        imageUrl: JessicaSchena
    },
    {
        name: 'Milena Bovolenta',
        role: 'AML and Production Manager',
        imageUrl:MilenaB
    },
    {
        name: 'Monica Mantovani',
        role: 'Anti-Money Laundering',
        imageUrl:MonicaM
    },
    {
        name: 'Giorgia Tinelli',
        role: 'Anti-Money Laundering',
        imageUrl:GiorgiaT
    },
    {
        name: 'Diana Petrisor',
        role: 'Anti-Money Laundering',
        imageUrl:DianaPetrisor
    },
    {
        name: 'Barbara Lorenzoni',
        role: 'Events Manager',
        imageUrl:BarbaraL
    },
    {
        name: 'Andrea Rebella',
        role: 'Junior Events Specialist',
        imageUrl:RebellaA
    },
    {
        name: 'Marcela Salazar',
        role: 'Licensing Office Manager',
        imageUrl:MarcelaS
    },
    {
        name: 'Paola Pasqualin',
        role: 'Legal Counsel',
        imageUrl:PaolaP
    },
    {
        name: 'Irada Pallanca',
        role: 'Digital Communication Manager & Digital Strategist',
        imageUrl:IradaP
    },
    {
        name: 'Sara Begalli',
        role: 'Social Media Specialist',
        imageUrl:SaraB
    },
    {
        name: 'Matteo Merlin',
        role: 'Marketing Manager',
        imageUrl:MatteoMerlin
    },
    {
        name: 'Andrea Guerra',
        role: 'Marketing & Promotion Manager',
        imageUrl:AndreaGuerra
    },
    {
        name: 'Alice Zuffellato',
        role: 'Jr. Marketing Specialist',
        imageUrl:AliceZuffellato
    },
    {
        name: 'Denny De Caro',
        role: 'SEO & GEO Analyst',
        imageUrl:DennyDecaro
    },
    {
        name: 'Beatrice Ruzzenente',
        role: 'Graphic Designer',
        imageUrl:BeatriceRuzzenente
    },
    {
        name: 'Jody Fustini',
        role: 'IT Manager',
        imageUrl:JodyF
    },
    {
        name: 'Michele Malagnini',
        role: 'Network Manager',
        imageUrl:MicheleM
    },
     {
        name: 'Cosimo Russo',
        role: 'Network Manager',
        imageUrl:Cosimo
    },
    {
        name: 'Denis Righelli',
        role: 'Jr. System Admin',
        imageUrl:DenisR
    },
    {
        name: 'Cristiano Silvestri',
        role: 'DB Developer',
        imageUrl:Silvestri
    },
    {
        name: 'Tommaso Poli',
        role: 'Software Engineer',
        imageUrl:TommasoP
    },
    {
        name: 'Alessio Cutrona',
        role: 'App Developer',
        imageUrl:AlessioC
    },
    {
        name: 'Mihai Cristian Trusca',
        role: 'Web Developer',
        imageUrl:CristianT
    },
    {
        name: 'Chiara Bissolo',
        role: 'Web Developer',
        imageUrl:ChiaraBissolo
    },
    {
        name: 'Alessandro Zeggiotti',
        role: 'Backend Developer',
        imageUrl:Zeggiotti
    },
    {
        name: 'Michele Lochi',
        role: 'Backend Developer',
        imageUrl:MicheleLochi
    },
    {
        name: 'Mattia Zapparoli',
        role: 'Backend Developer',
        imageUrl:MattiaZapparoli
    },
   
    {
        name: 'Arianna Masotto',
        role: 'Office Hospitality',
        imageUrl:Arianna
    },
    {
        name: 'Roberta Valerio',
        role: 'Office Hospitality Assistant',
        imageUrl:Roberta
    },
  ]
  
  export default function Backoffice() {
    // const [rotation, setRotation] = useState(false);
    // const [imageIndex, setImageIndex] = useState(false);

    // let i = 1; 

    // const handleClick = (name) => {
    //     if (name === 'Andrea Guerra') {
    //         if (i < 7) {
    //             i++;
    //             setImageIndex(false);
    //             return;
    //         }
    //         if (i === 7) { 
    //             setRotation(true); 
    //             setTimeout(() => {
    //                 setImageIndex(true);
    //             },1500)
    //             setTimeout(() => {
    //                 setRotation(false); 
    //             },2000)
    //             i = 1; 
    //             return;
    //         }
    //     }
    // };

    const [activeEgg, setActiveEgg] = useState(null);
    const [rotation, setRotation] = useState(null);
    const [clickState, setClickState] = useState({
        name: null,
        count: 0,
    });

    
    const handleClick = (name) => {
        let count = 1;

        if (clickState.name === name) {
            count = clickState.count + 1;
        }

        setClickState({ name, count });
        if (count < 7) return;
        setClickState({ name: null, count: 0 });

        switch (name) {
            case "Andrea Guerra":
                setRotation(name);

                setTimeout(() => {
                    setActiveEgg("Andrea Guerra");
                }, 1500);
                setTimeout(() => {
                    setRotation(null);
                }, 2000);
                break;

            case "Denny De Caro":
                setRotation(name);

                setTimeout(() => {
                    setActiveEgg("Denny De Caro");
                }, 1500);
                setTimeout(() => {
                    setRotation(false);
                }, 2000);
                break;

            default:
                break;
        }
    };

    return (
        <>
            <ul
                role="list"
                className="mx-auto mt-20 grid max-w-2xl grid-cols-2 gap-x-8 gap-y-16 text-center sm:grid-cols-3 md:grid-cols-4 lg:mx-0 lg:max-w-none lg:grid-cols-5 xl:grid-cols-6"
            >
                {people.map((person) => (
                    <li key={person.name} 
                    data-aos="fade-in" data-aos-duration="1500"
                    onClick={() => handleClick(person.name)}
                    >
                        {/* <img
                            className={`mx-auto h-24 w-24 rounded-full ${person.name === 'Andrea Guerra' && rotation && 'rotate'}`}
                            src={person.name === 'Andrea Guerra' && imageIndex ? NewImage : person.imageUrl}
                            alt="staff"
                        /> */}
                        {person.name === "Denny De Caro" && activeEgg === "Denny De Caro" ? (
                            <video
                                src={NewVideo}
                                autoPlay
                                loop
                                muted
                                playsInline
                                className={`mx-auto h-24 w-24 rounded-full ${
                                    rotation === person.name ? "rotate" : ""
                                }`}
                            />
                            ) : (
                            <img
                                src={
                                    person.name === "Andrea Guerra" &&
                                    activeEgg === "Andrea Guerra"
                                    ? NewImage
                                    : person.imageUrl
                                }
                                className={`mx-auto h-24 w-24 rounded-full ${
                                    rotation === person.name ? "rotate" : ""
                                }`}
                                alt="staff"
                            />
                        )}
                        <h3 className="mt-6 text-base font-semibold leading-7 tracking-tight text-neutral-200">{person.name}</h3>
                        {/* <p className="text-sm leading-6 text-neutral-400">{person.role}</p> */}
                        <p className="text-sm leading-6 text-neutral-400">
                            {person.name === "Denny De Caro" && activeEgg === "Denny De Caro"
                                ? "The Ultimate Ticket Master"
                                : person.role}
                        </p>
                    </li>
                ))}
            </ul>
        </>
    )
  }
  